"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var styles = (0, _makeStyles.default)(function (theme) {
  return {
    text: {
      "& span.hidden": {
        display: "none"
      },
      "& ul": {
        listStyle: "none",
        margin: theme.spacing(2, 0),
        "& li": {
          margin: theme.spacing(1, 0),
          paddingLeft: theme.spacing(3),
          position: "relative",
          "&:before": {
            background: theme.palette.text.primary,
            borderRadius: "50%",
            content: "''",
            height: 6,
            left: theme.spacing(1),
            position: "absolute",
            top: "50%",
            transform: "translate(0, -50%)",
            width: 6
          }
        }
      },
      "& a": {
        fontWeight: 700
      }
    },
    show: {
      "& span.hidden": {
        display: "block"
      }
    }
  };
});
var _default = styles;
exports.default = _default;